/*
 * @Desc: 一级分销商的业务员
 * @Author: may.li
 * @Date: 2023-03-08 17:28:40
 * @LastEditors: may.li
 * @LastEditTime: 2023-03-16 14:58:14
 */

import axios from '../http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来
const index = {
	// 业务员信息
	info(params){
		return axios.get("/home/salesman/info", { params: params });
	},
	// 业务员禁用&恢复
	status(params){
		return axios.post('/home/firstagent/salesman/status', qs.stringify(params));
	},
	// 业务员的扫码记录
	saomalog(params){
		return axios.get("/home/salesman/saoma/log", { params: params });
	},
	// 业务员查看一级分销商的二级分销商
	agentlist(params){
		return axios.get("/home/firstagent/agent/list", { params: params });
	},
	// 业务员查看二级分销商所有二维码
	agentqrcodelist(params){
		return axios.get("/home/agent/qrcode/list", { params: params });
	},
	// 业务员给二级分销商绑码，输入二维码编号或者扫码
	bindqrcode(params){
		return axios.post('/home/salesman/agent/qrcode', qs.stringify(params));
	},
	// 验证业务员是否能给二级分销商绑码
	verifyqrcode(params){
		return axios.get("/home/salesman/verify/bindqrcode", { params: params });
	}
}
// 导出接口
export default index